/** @format */

export const AUTO_MANAGEMENT = 'auto gestione';
export const SENDED_TO_WAREHOUSE = 'inoltrata al magazzino';
export const WAREHOUSE_CHECK = 'verifica magazzino';
export const WAREHOUSE_CHECK_ENDED = 'controllo terminato';
export const COMPLETED_SOLDED = 'completata con vendita';
export const COMPLETED_UNSOLDED = 'completata senza vendita';
export const COMPLETED_UNAVAILABLE = 'completata non disponibile';
export const BARGAINING_SALE = 'contrattazione vendita';
export const NO_AVAILABLE_OPTION = 'nessuna opzione disponibile';
